export default "__VITE_ASSET__DNkMalC___"